(() => {
  'use strict';
  const analytics = window.DamaAnalytics;
  if (!analytics || window.__damaJourneyStarted) return;
  window.__damaJourneyStarted = true;
  const plFinderLocation = window.location.origin === 'https://damacouture.pl'
    && ['pl', 'pl-pl'].includes((document.documentElement.lang || '').toLowerCase());
  const storageKey = 'dama:finder-entry:v1';
  const finder = document.querySelector('.dama-store-finder');
  const sourceTypes = new Set(['product', 'collection', 'homepage', 'navigation', 'brand', 'article', 'local', 'finder', 'direct', 'other']);
  let opened = false, entry;
  let lastSelection = { id: '', at: 0 };
  const normal = value => String(value || '').normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().replace(/ß/g, 'ss').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  function text(node) {
    if (!node) return '';
    const copy = node.cloneNode(true);
    copy.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
    return copy.textContent.trim();
  }
  function locationParameters(card) {
    const values = { gdzie: 'finder' };
    const salon = text(card.querySelector('.richtext > p:first-child strong')).replace(/\s+/g, ' ').slice(0, 80);
    if (salon) values.salon = salon;
    const address = text(card.querySelector('.richtext > p:nth-child(2)'));
    const cities = new Set();
    address.split(/\n|,/).forEach(line => {
      const match = /^\s*(?:[A-Z]{1,2}-)?(?:\d{2}-\d{3}|\d{3}\s\d{2}|\d{4,5}(?:\s?[A-Z]{2})?)\s+(\D[^\d]*?)\s*$/.exec(line);
      if (match) cities.add(match[1].trim());
    });
    if (cities.size === 1) values.miasto = [...cities][0].slice(0, 60);
    return values;
  }
  function salonId(value) {
    let hash = 14695981039346656037n;
    for (const byte of new TextEncoder().encode(value)) hash = BigInt.asUintN(64, (hash ^ BigInt(byte)) * 1099511628211n);
    return `salon_${hash.toString(16).padStart(16, '0')}`;
  }
  function cardRecord(card) {
    if (!card) return null;
    const country = (card.dataset.country || '').toLowerCase();
    const name = normal(text(card.querySelector('.richtext > p:first-child strong')));
    const address = normal(text(card.querySelector('.richtext > p:nth-child(2)')));
    if (!/^[a-z]{2}$/.test(country) || !name || !address) return null;
    const id = salonId(`${country}|${name}|${address}`);
    card.dataset.damaSalonId = id;
    return { id, name, address, ...(plFinderLocation ? { location: locationParameters(card) } : {}) };
  }
  function bubbleRecord(bubble) {
    const shell = bubble.closest('.gm-style-iw') || bubble.closest('.gm-style-iw-c') || bubble.parentElement;
    const name = normal(text(shell?.querySelector('.dama-finder-bubble-title, .gm-style-iw-ch .title')));
    const address = normal(text(bubble.querySelector('.richtext > p:first-child')));
    if (!name || !address) return null;
    const matches = [...finder.querySelectorAll('[data-finder-list] .stores__list-item')].filter(card =>
      normal(text(card.querySelector('.richtext > p:first-child strong'))) === name && normal(text(card.querySelector('.richtext > p:nth-child(2)'))) === address
    );
    if (matches.length !== 1) return null;
    const record = cardRecord(matches[0]);
    if (record) bubble.dataset.damaSalonId = record.id;
    return record;
  }
  function cleanEntry(value) {
    const result = { source_type: sourceTypes.has(value?.source_type) ? value.source_type : 'other' };
    if (/^[a-z0-9][a-z0-9-]{0,99}$/.test(value?.product_handle || '')) result.product_handle = value.product_handle;
    if (/^\d{1,20}$/.test(String(value?.collection_id || ''))) result.collection_id = String(value.collection_id);
    return result;
  }
  function clearEntry() { try { window.sessionStorage.removeItem(storageKey); } catch (_) {} }
  function finderLink(link) {
    if (!link) return false;
    try {
      const target = new URL(link.href, window.location.href);
      const expected = new URL(document.body.dataset.damaFinderUrl || '/pages/store-finder', window.location.origin);
      return target.origin === window.location.origin && target.pathname.replace(/\/$/, '') === expected.pathname.replace(/\/$/, '');
    } catch (_) { return false; }
  }
  function rememberEntry(link) {
    if (!analytics.allowed()) { clearEntry(); return; }
    const source = cleanEntry(analytics.context());
    if (!['product', 'collection'].includes(source.source_type) && link.closest('.dama-header,.dama-footer')) source.source_type = 'navigation';
    try { window.sessionStorage.setItem(storageKey, JSON.stringify({ ...source, at: Date.now() })); } catch (_) {}
  }
  function readEntry() {
    try {
      const value = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null');
      clearEntry();
      if (value && Number.isFinite(value.at) && Date.now() >= value.at && Date.now() - value.at < 1800000) return cleanEntry(value);
    } catch (_) { clearEntry(); }
    try {
      const url = new URL(document.referrer);
      if (/^(www\.)?damacouture\.(de|pl|com|co\.uk|it|fr|es)$/.test(url.hostname)) {
        const product = /\/products\/([a-z0-9-]+)\/?$/.exec(url.pathname);
        if (product) return cleanEntry({ source_type: 'product', product_handle: product[1] });
        if (/\/collections\/[a-z0-9-]+\/?$/.test(url.pathname)) return { source_type: 'collection' };
        return { source_type: 'other' };
      }
    } catch (_) {}
    return { source_type: 'direct' };
  }
  function openFinder() {
    if (!finder || opened || !analytics.allowed()) return;
    entry ||= readEntry();
    opened = analytics.track('dama_finder_opened', entry);
  }
  function selected(record, surface) {
    if (!record || !analytics.allowed()) return;
    if (lastSelection.id === record.id && Date.now() - lastSelection.at < 500) return;
    openFinder();
    if (analytics.track('dama_salon_selected', { ...entry, salon_id: record.id, selection_surface: surface })) lastSelection = { id: record.id, at: Date.now() };
  }
  function contactAction(link, bubble) {
    const href = (link.getAttribute('href') || '').trim();
    if (/^tel:\+?[\d\s().-]{6,25}$/i.test(href)) return 'phone';
    if (['fr', 'es'].includes((document.documentElement.lang || '').toLowerCase().split('-')[0]) && /^mailto:[^\s@:]+@[^\s@:]+\.[^\s@:]+$/i.test(href)) return 'email';
    let url;
    try { url = new URL(href, window.location.href); } catch (_) { return ''; }
    if (!/^https?:$/.test(url.protocol) || link.closest('.stores__bubble-buttons')) return '';
    if (link.dataset.damaContactAction === 'appointment') return 'appointment';
    if (bubble && !link.closest('.stores__bubble .richtext')) return '';
    return 'website';
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (!target) return;
    const link = target.closest('a[href]');
    if (link && finderLink(link)) { rememberEntry(link); return; }
    if (!finder || !finder.contains(target)) return;
    const card = target.closest('[data-finder-list] .stores__list-item');
    const bubble = target.closest('.stores__bubble');
    if (link && (card || bubble)) {
      if (!analytics.allowed()) return;
      const action = contactAction(link, bubble);
      const record = action && (card ? cardRecord(card) : bubbleRecord(bubble));
      if (record) { openFinder(); analytics.track('dama_salon_contact_clicked', { ...entry, salon_id: record.id, contact_action: action, ...(record.location || {}) }); }
      return;
    }
    if (card && !link) {
      const record = cardRecord(card);
      if (record) selected(record, 'list');
      return;
    }
  }, true);
  if (finder) {
    document.addEventListener('dama:finder-marker-selected', event => {
      const index = event.detail?.storeIndex;
      if (!analytics.allowed() || !Number.isSafeInteger(index) || index < 0 || index > 100000) return;
      const card = finder.querySelector(`[data-finder-list] .stores__list-item[data-idx="${index}"]`);
      selected(cardRecord(card), 'map');
    });
  }
  document.addEventListener('dama:analytics-consent', event => {
    if (!event.detail?.allowed) { clearEntry(); entry = undefined; }
    else openFinder();
  });
  if (!analytics.allowed()) clearEntry();
  openFinder();
})();

